document.cookie = "client_timezone=" + Intl.DateTimeFormat().resolvedOptions().timeZone + "; path=/";


